<section>
  <header
    (click)="toggleExpanded()"
    (keydown.enter)="toggleExpanded()"
    (keydown.space)="toggleExpanded()"
    [ngClass]="expanded ? 'expanded' : 'collapsed'"
    tabindex="0"
    [title]="[(expanded ? 'Hide ' : 'Show ') + 'Sort order for this field']"
    >
    <mat-icon fontIcon="sort_by_alpha"></mat-icon>
    <h3>
      Sort by
      @if (hasChanged) {
        <span class="has-changed-indicator" title="Update field changes below">*</span>
      }
    </h3>
    <mat-icon fontIcon="expand_more" class="expand-icon"></mat-icon>
  </header>
  @if (expanded) {
    <table class="table-full-width" @configSectionsInOut>
      <tr>
        <td><p>Select a field and the sort direction</p></td>
      </tr>
      <tr>
        <td class="sort-grid">
          <aside>
            <mat-select
              class="full-width"
              [(ngModel)]="sortField"
              placeholder="Choose a field..."
              title="Choose a field to sort by"
              (selectionChange)="updateParent(ChangeEventSrc.SortField)"
              >
              @for (field of sortFields; track field.path) {
                <mat-option [value]="field">
                  {{ field.label }}
                </mat-option>
              }
            </mat-select>
            @if (sortField?.type === 'to-one') {
              <mat-select
                class="full-width"
                [(ngModel)]="sortChildField"
                placeholder="Choose a child field..."
                title="Choose a child field to sort by"
                (selectionChange)="updateParent(ChangeEventSrc.SortChildField)"
                @selectInOut
                >
                @for (field of getSortChildFields(); track field.path) {
                  <mat-option [value]="field">
                    {{ field.label }}
                  </mat-option>
                }
              </mat-select>
            }
          </aside>
          <mat-select
            class="full-width"
            [(ngModel)]="sortDirn"
            placeholder="Sort by..."
            title="Sort by"
            (selectionChange)="updateParent(ChangeEventSrc.SortDirn)"
            >
            @switch (sortField?.type === 'to-one' ? sortChildField?.type : sortField?.type) {
              @case ('string') {
                <mat-option [value]="SortDirn.ASC">A to Z</mat-option>
              }
              @case ('date') {
                <mat-option [value]="SortDirn.ASC">Earliest to Latest</mat-option>
              }
              @default {
                <mat-option [value]="SortDirn.ASC">Lowest to Highest</mat-option>
              }
            }
            @switch (sortField?.type === 'to-one' ? sortChildField?.type : sortField?.type) {
              @case ('string') {
                <mat-option [value]="SortDirn.DSC">Z to A</mat-option>
              }
              @case ('date') {
                <mat-option [value]="SortDirn.DSC">Latest to Earliest</mat-option>
              }
              @default {
                <mat-option [value]="SortDirn.DSC">Highest to Lowest</mat-option>
              }
            }
          </mat-select>
        </td>
      </tr>
    </table>
  }
</section>
